import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import Spinner from "./Spinner"; 
import { AuthContext } from "../context/AuthContext";
import "../style/odds.css"; 

import api_url from "../constants";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UpdateMatchDetails() {
  const [authContext] = useContext(AuthContext);
  const config = {
    headers: { Authorization: `Bearer ${authContext.token}` },
  };
  const [dataLoading, setDataLoading] = useState(true);
  const [matchDetails, setMatchDetails] = useState([]);

  const fetchMatchDetails = async () => {
    try {
      const response = await axios.get(`${api_url}/api/allGetMatchList`, config);
      setMatchDetails(response.data.matchList);
      setDataLoading(false);
    } catch (error) {
      console.error("Error fetching match details:", error);
      setDataLoading(false);
    }
  };

  const blockMatch = async (matchId, is_blocked) => {
    try {
      const response = await axios.post(
        `${api_url}/api/matchBlocked`,
        { matchId, is_blocked },
        config
      );
      if (response.data.status === true) {
        toast.success(response.data.msg);
      } else {
        toast.error("Failed to block match");
      }
      fetchMatchDetails();
    } catch (error) {
      console.error("Error blocking match:", error);
    }
  };

  useEffect(() => {
    fetchMatchDetails();
  }, []);

  return (
    <div className="page-container">
      <ToastContainer position="top-right" autoClose={5000} theme="light" />
      
      {/* FIX: Added marginTop here. 
         Adjust '100px' to match the height of your navbar 
      */}
      <div className="page-header" style={{ marginTop: "70px" }}>
        <h1>Update Match Details</h1>
      </div>

      <div className="pr-box">
        
        <div className="prbox-header">
          <span>Match List Management</span>
        </div>

        <div className="prbox-body table-responsive">
          <table className="match-table">
            <thead>
              <tr>
                <th>Event ID</th>
                <th>Match Name</th>
                <th>Status</th>
                <th style={{ textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataLoading ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "30px" }}>
                    <Spinner color="#16a085" />
                  </td>
                </tr>
              ) : matchDetails.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                    No matches found
                  </td>
                </tr>
              ) : (
                matchDetails.map((match) => (
                  <tr key={match.event_id}>
                    <td className="bold-num" data-label="Event ID">
                        {match.event_id}
                    </td>
                    <td data-label="Match Name">
                        {match.event_name}
                    </td>
                    <td data-label="Status">
                      {match.is_blocked ? (
                        <span className="status-blocked">BLOCKED</span>
                      ) : (
                        <span className="status-active">ACTIVE</span>
                      )}
                    </td>
                    <td style={{ textAlign: "center" }} data-label="Action">
                      <button
                        onClick={() => blockMatch(match.event_id, match.is_blocked)}
                        className={`action-btn ${match.is_blocked ? "btn-unblock" : "warn-btn"}`}
                      >
                        {match.is_blocked ? "Unblock" : "Block"}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UpdateMatchDetails;